module.exports = __webpack_public_path__ + "static/media/AppointmentMt.60115d86.svg";